

import emailIcon from './images/icons/email-icon.svg';
import wtspIcon from './images/icons/whatsapp-icon.svg';
import reactIcon from './images/react-icon.svg';

export default function Footer () {




    return(


        <div class='footer' style={{'z-index': '3'}}>



        <div class='footerContainer' style={{'margin-top' : '1%', 'margin-bottom' : '5%'}}>

            <div class="halfV">

                    <div class="footerSection"  id="#footerContact" style={{  'border-top': '0px'}}>

                        <div class='footerItem'>
                                <div class='footerIcon'>
                                    <a href="tel:+4917659532446"><img src={wtspIcon} width="17px" height="18px" margin-left="1px"></img></a>
                                    </div>

                                <div class='footerIcon'>
                                    <a href="mailto:benzianeoyacine@gmail.com"><img src={emailIcon} width="20px" height="20px"></img></a>
                                </div>
                                </div>  
                    </div>
                    

                    <div class="footerSection"  id="#footerSign" style={{  'border-top': '0px', 'display': 'flex', 'align-items': 'end'}}>
                        
                     
                        <div class='footerList' id = "signLong" style={{'font-size': '15px'}}>Created by Yacine Benziane w/<img src={reactIcon} style = {{height: '21px', 'transform': 'translate(3px,5px)'}}/></div>
                        <div class='footerList' id = "signSmall" style={{'font-size': '15px'}}>Created by <br/> Yacine Benziane</div>

                    </div>
            </div>


        </div>

        </div>
    )
}